import { isPartnerSignup } from '../../flow/selectors';
export default (() => {
  const endpoint = isPartnerSignup() ? `/signup/v1/validation/partner-domain` : '/signup/v1/validation/domain';
  return endpoint;
});